import { FEATURE_LIST, PLAN_TYPE } from '../constants/subscription';

export const SUBSCRIPTION_FEATURES = {
  basic: [
    FEATURE_LIST.ACTIVE_LIVESTOCK_WIDGET,
    FEATURE_LIST.CALVES_PRODUCED_WIDGET,
    FEATURE_LIST.CALVES_WEANED_WIDGET,
    FEATURE_LIST.LIVESTOCK_COUNT_WIDGET,
    FEATURE_LIST.WEATHER_WIDGET,
    FEATURE_LIST.CALENDAR_WIDGET,
    FEATURE_LIST.TASKS_WIDGET,
    FEATURE_LIST.MAP_WIDGET,
    FEATURE_LIST.LIVESTOCK_ANALYSIS_WIDGET,
    FEATURE_LIST.FARM_FILTER
  ],
  tracking: [
    FEATURE_LIST.NOTIFICATION_ICON,
    FEATURE_LIST.ACTIVE_LIVESTOCK_WIDGET,
    FEATURE_LIST.ACTIVE_NOTIFICATIONS_WIDGET,
    FEATURE_LIST.ACTIVE_RULES_WIDGET,
    FEATURE_LIST.LIVESTOCK_COUNT_WIDGET,
    FEATURE_LIST.LAST_NOTIFICATIONS_WIDGET,
    FEATURE_LIST.RULES_WIDGET,
    FEATURE_LIST.MAP_TRACKING,
    FEATURE_LIST.TRACK_ANIMAL,
    FEATURE_LIST.RULES_FILTER,
    FEATURE_LIST.RULES_WIDGET,
    FEATURE_LIST.LAST_NOTIFICATIONS_WIDGET,
    FEATURE_LIST.NOTIFICATION_ICON
  ],
  measures: [FEATURE_LIST.MEASURES_TAB],
  treatment: [FEATURE_LIST.TREATMENT_TAB],
  breeding: [FEATURE_LIST.BREEDING_TAB],
  farm: []
};

export const EXPENDED_DEFAULT_LIVESTOCK_LIST = [
  'age',
  'assignedGeofence',
  'brand',
  'breedName',
  'breedingStatus',
  'calfAge',
  'calfLivestockId',
  'calfMgmtId',
  'colour',
  'comments',
  'damId',
  'dateSold',
  'description',
  'dob',
  'earMark',
  'eartag_management_id',
  'farm',
  'identifier',
  'livestockType',
  'lossDate',
  'lossReason',
  'numbersCalves',
  'officialTagId',
  'polledHorned',
  'purchaseDate',
  'purchaseNotes',
  'purchasedFrom',
  'purchasedWhere',
  'sex',
  'sireId',
  'soldTo',
  'specie',
  'specieName',
  'weight'
];

const DEFAULT_GRAZING_LIST = [
  'pasture',
  'id',
  'name',
  'size',
  'forage_species',
  'assigned_groups',
  'rotation_start_date',
  'rotation_end_date',
  'duration',
  'rotation_stocking_rate',
  'rotation_lsu_days_grazing',
  'rest_since_last_rotation',
  'rest_until_next_rotation'
];

const EXPENDED_GRAZING_LIST = [
  ...DEFAULT_GRAZING_LIST,
  'expected_tracked_livestock',
  'actual_tracked_livestock',
  'forage_cover_before_rotation',
  'forage_height_before_rotation',
  'biomass_weight_before_rotation',
  'forage_cover_after_rotation',
  'forage_height_after_rotation',
  'biomass_weight_after_rotation'
];

export const TABLE_COLUMNS = {
  [FEATURE_LIST.LIVESTOCK_COUNT_WIDGET]: {
    basic: ['geofenceName', 'assignedLivestock', 'unassignedAnimals'],
    trial: ['geofenceName', 'assignedLivestock', 'unassignedAnimals'],
    advanced: ['geofenceName', 'assignedLivestock', 'unassignedAnimals']
  },

  [FEATURE_LIST.LIVESTOCK_LIST]: {
    basic: [...EXPENDED_DEFAULT_LIVESTOCK_LIST],
    trial: [...EXPENDED_DEFAULT_LIVESTOCK_LIST],
    advanced: [...EXPENDED_DEFAULT_LIVESTOCK_LIST]
  },

  [FEATURE_LIST.FARMS_LIST]: {
    basic: [
      'select',
      'farmId',
      'farmName',
      'farmAddress',
      'farmSize',
      'farmPerimeter',
      'farmHerd',
      'assignedLivestock'
    ],
    trial: [
      'select',
      'farmId',
      'farmName',
      'farmAddress',
      'farmSize',
      'farmPerimeter',
      'farmHerd',
      'assignedLivestock'
    ],
    advanced: [
      'select',
      'farmId',
      'farmName',
      'farmAddress',
      'farmSize',
      'farmPerimeter',
      'farmHerd',
      'assignedLivestock'
    ]
  },
  [FEATURE_LIST.FARM_DETAILS_FIELDS]: {
    basic: [
      'identifier',
      'name',
      'address',
      'house_number',
      'city',
      'postal_code',
      'country',
      'size',
      'circumference',
      'holding_numbers',
      'animals_count',
      'description'
    ],
    trial: [
      'identifier',
      'name',
      'address',
      'house_number',
      'city',
      'postal_code',
      'country',
      'size',
      'circumference',
      'holding_numbers',
      'animals_count',
      'description'
    ],
    advanced: [
      'identifier',
      'name',
      'address',
      'house_number',
      'city',
      'postal_code',
      'country',
      'size',
      'circumference',
      'holding_numbers',
      'animals_count',
      'description'
    ]
  },
  [FEATURE_LIST.GEOFENCES_LIST]: {
    trial: [
      'select',
      'index',
      'id',
      'geofenceName',
      'geofenceSize',
      'geofencePerimeter',
      'assignedLivestock',
      'assignedGroups',
      'farm'
    ],
    basic: [
      'select',
      'index',
      'id',
      'geofenceName',
      'geofenceSize',
      'geofencePerimeter',
      'assignedLivestock',
      'assignedGroups',
      'farm'
    ],
    advanced: [
      'select',
      'index',
      'id',
      'geofenceName',
      'geofenceSize',
      'geofencePerimeter',
      'assignedLivestock',
      'assignedGroups',
      'farm'
    ]
  },
  [FEATURE_LIST.SITES_LIST]: {
    trial: ['select', 'id', 'siteName', 'sitetype', 'siteGeofence', 'siteDescription', 'farm'],
    basic: ['select', 'id', 'siteName', 'sitetype', 'siteGeofence', 'siteDescription', 'farm'],
    advanced: ['select', 'id', 'siteName', 'sitetype', 'siteGeofence', 'siteDescription', 'farm']
  },
  [FEATURE_LIST.GRAZING_LIST]: {
    [PLAN_TYPE.ADVANCED]: EXPENDED_GRAZING_LIST,
    [PLAN_TYPE.COMPLETED]: EXPENDED_GRAZING_LIST,
    [PLAN_TYPE.BASIC]: DEFAULT_GRAZING_LIST,
    [PLAN_TYPE.TRACKING]: DEFAULT_GRAZING_LIST,
    [PLAN_TYPE.TRIAL]: DEFAULT_GRAZING_LIST
  }
};
